import React from 'react'
import ISalary from './salary.interface'

const Salary: React.FC<ISalary> = ({ data, thisYearsData, setThisYearsData }) => {
  const tableCells = [
    {
      name: 'year',
      value: data.year,
    },
    {
      name: 'salaryAmountTfl',
      value: data.salaryAmountTfl,
    },
    {
      name: 'salaryAmountTrf',
      value: data.salaryAmountTrf,
    },
    {
      name: 'salaryAmountPainters',
      value: data.salaryAmountPainters,
    },
    {
      name: 'totalAmount',
      value: data.totalAmount,
    },
  ]

  const handleNewData = (name: string, value: number) => {
    if (thisYearsData && setThisYearsData) {
      const thisYearsDataClone = Object.assign({}, thisYearsData)
      if (
        name === 'salaryAmountTfl' ||
        name === 'salaryAmountTrf' ||
        name === 'salaryAmountPainters' ||
        name === 'totalAmount'
      ) {
        thisYearsDataClone[name] = value
      }
      setThisYearsData(thisYearsDataClone)
    }
  }

  return data ? (
    <tr className="tbody-tr">
      {tableCells.map((cell, index) => {
        if (thisYearsData) {
          if (index === 0) {
            return (
              <td key={index} className="td  w-1/5">
                {
                  <p className="w-full bg-fastigoWhite table-text">
                    {cell.value ? cell.value : ''}
                  </p>
                }
              </td>
            )
          } else {
            return (
              <td key={index} className="td w-1/5">
                <input
                  type="number"
                  defaultValue={cell.value.toString()}
                  className="td"
                  onChange={(e) => handleNewData(cell.name, parseInt(e.target.value, 10))}
                />
              </td>
            )
          }
        }
        return (
          <td key={index} className="td  w-1/5">
            <p className="w-full table-text">{cell.value}</p>
          </td>
        )
      })}
    </tr>
  ) : null
}

export default Salary
